import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const partners = [
  {
    name: 'Karl Group Holdings Corp.',
    country: '🇵🇭 Philippines',
    domain: 'Medical Equipment Distribution',
    url: 'karlgroup.org',
    desc: 'The leading Philippine healthcare group. Specializes in medical equipment distribution and healthcare solutions throughout Mindanao, Manila, the Visayas, and Luzon.',
    icon: 'ri-heart-pulse-line',
    tags: ['Medical Devices', 'Philippines', 'Healthcare'],
    image: 'https://public.readdy.ai/ai/img_res/6779bef7d87cfef6876aca1a204a6b66.jpg',
  },
  {
    name: 'Inspiraz Technology Pte Ltd',
    country: '🇸🇬 Singapore',
    domain: 'Machine Vision Platform (Wizer)',
    url: 'vizcam.net / inspiraz.com',
    desc: 'A Singapore-based advanced technology company with 20+ years of machine vision and automation expertise, delivering the Wizer platform to manufacturers across Asia.',
    icon: 'ri-eye-2-line',
    tags: ['Machine Vision', 'Singapore', 'AI Deep Learning'],
    image: 'https://readdy.ai/api/search-image?query=Singapore%20modern%20technology%20company%20headquarters%20sleek%20corporate%20office%20building%20glass%20facade%20night%20lights%20city%20skyline%20advanced%20engineering%20firm%20sophisticated%20urban%20environment&width=600&height=400&seq=fixcope-inspiraz-001&orientation=landscape',
  },
];

export default function PartnersEn() {
  const headerAnim = useScrollAnimation();
  const gridAnim = useScrollAnimation({ rootMargin: '0px 0px -40px 0px' });

  return (
    <section id="partners" className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div
          ref={headerAnim.ref}
          className={`text-center mb-16 transition-all duration-700 ${headerAnim.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          <div className="inline-flex items-center gap-2 mb-5">
            <span className="w-8 h-[2px] bg-[#E8650A]"></span>
            <span className="text-xs font-semibold text-[#E8650A] uppercase tracking-widest whitespace-nowrap">Global Partners</span>
            <span className="w-8 h-[2px] bg-[#E8650A]"></span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A2530] mb-4">Verified Global Partners</h2>
          <p className="text-gray-500 text-[15px] max-w-lg mx-auto">
            We deliver world-class solutions through collaboration with our verified global partners.
          </p>
        </div>

        {/* Partner Cards */}
        <div
          ref={gridAnim.ref}
          className={`grid grid-cols-1 md:grid-cols-2 gap-8 transition-all duration-700 ${gridAnim.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          {partners.map((p, i) => (
            <div
              key={i}
              className="rounded-2xl overflow-hidden border border-gray-100 hover:border-[#E8650A]/40 transition-all duration-300 hover:-translate-y-1 group"
            >
              {/* Image */}
              <div className="h-48 overflow-hidden">
                <img
                  src={p.image}
                  alt={p.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              {/* Content */}
              <div className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#E8650A]/10">
                      <i className={`${p.icon} text-lg text-[#E8650A]`}></i>
                    </div>
                    <div>
                      <h3 className="text-base font-bold text-[#1A2530] leading-tight">{p.name}</h3>
                      <span className="text-xs text-gray-400">{p.country}</span>
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <span className="inline-block px-3 py-1 bg-[#FEF3E8] text-[#E8650A] text-xs font-semibold rounded-full whitespace-nowrap">{p.domain}</span>
                </div>
                <p className="text-[13px] text-gray-500 leading-relaxed mb-4">{p.desc}</p>
                <div className="flex flex-wrap gap-2 mb-4">
                  {p.tags.map((tag, ti) => (
                    <span key={ti} className="px-2 py-1 bg-gray-50 text-gray-500 text-[11px] rounded-md border border-gray-100 whitespace-nowrap">
                      #{tag}
                    </span>
                  ))}
                </div>
                <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                  <span className="text-xs text-gray-400">{p.url}</span>
                  <button
                    onClick={() => {
                      const el = document.querySelector('#contact');
                      if (el) el.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="flex items-center gap-1 text-xs text-[#E8650A] font-semibold hover:gap-2 transition-all whitespace-nowrap cursor-pointer"
                  >
                    Partnership Inquiry <i className="ri-arrow-right-line"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Banner */}
        <div className={`mt-12 bg-[#1A2530] rounded-2xl p-8 flex flex-col md:flex-row items-center justify-between gap-6 transition-all duration-700 delay-300 ${gridAnim.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div>
            <h4 className="text-white font-bold text-lg mb-2">Interested in a global partnership?</h4>
            <p className="text-gray-400 text-sm">Let&apos;s explore new collaboration possibilities together with Fixcope.</p>
          </div>
          <button
            onClick={() => {
              const el = document.querySelector('#contact');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-6 py-3 bg-[#E8650A] text-white rounded-lg text-sm font-semibold hover:bg-[#C95508] transition-all whitespace-nowrap cursor-pointer shrink-0"
          >
            Get in Touch
          </button>
        </div>
      </div>
    </section>
  );
}
